import { render, staticRenderFns } from "./ServeOrder.vue?vue&type=template&id=26b209a6&scoped=true&"
import script from "./ServeOrder.vue?vue&type=script&lang=js&"
export * from "./ServeOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b209a6",
  null
  
)

export default component.exports